import PageShell from "../components/PageShell";
import { viewsFor } from "../content/views";
import seoPages from "../content/seo-pages.json";

const views = viewsFor("contact");
const seo = seoPages["/contact"];

export default function Contact() {
  return (
    <PageShell
      title={seo.title}
      description={seo.description}
      bodyClass=""
      dataFrame={null}
      views={views}
    />
  );
}
